<template>
  <Spin fix v-show="loading">
    <FFIcon type="circle-o-notch fa-spin fa-3x fa-fw" />
    <div>Loading...</div>
  </Spin>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="css"></style>
